export default __webpack_public_path__ + "static/media/file_icon.1dadae9d.svg";